export type CapabilityBadge = 'voice' | 'sms' | 'sip' | 'sip_registered' | 'sip_failed' | 'hosted_sms' | 'a2p';

export const BADGE_STYLES: Record<CapabilityBadge, { label: string; bg: string; color: string }> = {
  voice: { label: 'VOICE', bg: '#DBEAFE', color: '#2563EB' },
  sms: { label: 'SMS', bg: '#D1FAE5', color: '#059669' },
  sip: { label: 'SIP', bg: '#CCFBF1', color: '#0D9488' },
  sip_registered: { label: 'SIP Registered', bg: '#DCFCE7', color: '#16A34A' },
  sip_failed: { label: 'SIP Failed', bg: '#FEE2E2', color: '#DC2626' },
  hosted_sms: { label: 'Hosted SMS', bg: '#FFEDD5', color: '#EA580C' },
  a2p: { label: 'A2P', bg: '#FEF3C7', color: '#D97706' }
};

const BADGE_ORDER: CapabilityBadge[] = ['voice', 'sip', 'sip_registered', 'sip_failed', 'sms', 'hosted_sms', 'a2p'];

export function toCapabilityBadges(capabilities?: string[] | null): CapabilityBadge[] {
  const set = new Set((capabilities ?? []).map((cap) => cap.toLowerCase()));
  return BADGE_ORDER.filter((badge) => set.has(badge));
}
